export const contentResponse = {
  data: {
    EN: {
      header: {
        syfLogoAltText: 'Synchrony',
        userLogoAltText: 'Profile',
      },
      footer: {
        footerLinks: [
          {
            id: 'https://www.synchrony.com/syf',
            text: 'Synchrony',
            url: 'https://www.synchrony.com/syf',
          },
          {
            id: 'https://www.synchrony.com/privacy-policy.html',
            text: 'Online Privacy Policy',
            url: 'https://www.synchrony.com/privacy-policy.html',
          },
          {
            id: 'https://www.mysynchrony.com/terms-of-use.html',
            text: 'Online Usage Agreement',
            url: 'https://www.mysynchrony.com/terms-of-use.html',
          },
          {
            id: 'https://www.synchrony.com/gwas',
            text: 'Accessibility',
            url: 'https://www.synchrony.com/gwas',
          },
          {
            id: 'https://www.synchrony.com/legal/fraud-protection',
            text: 'Fraud Protection',
            url: 'https://www.synchrony.com/legal/fraud-protection',
          },
        ],
        footerMessage:
          'Your credit accounts are issued by Synchrony Bank. The Synchrony Bank Privacy Policy governs the use of your credit accounts. The use of this site is governed by the use of the Online Privacy Policy. The content and documents displayed may not all be provided in Spanish. Apple Wallet is a trademark of Apple Inc. Apple Pay is the lead brand and it’s the product you use to tap and pay. Apple Wallet is your digital wallet. Your card resides there and can use it anywhere Apple Pay or contactless payments are accepted. Google Pay, the Google Pay Logo, and Google Play Store are trademarks of Google LLC.',
      },
      salutation: {
        welcomeMessage: 'Welcome,',
        exclamationMark: '!',
      },
      accounts: {
        cardsTitle: 'My Cards',
        availableToSpendText: 'Available to spend',
        currentLimitText: 'Current limit',
        asOfDate: 'As of',
        usDollarSymbol: '$',
        portfolioLogoAltText: 'logo',
        accountPendedMessage:
          'You should receive your card with the account number in mail 7–10 days from the approval date.',
        unableToProvideAccountNumberText:
          'We are unable to provide your account number at this time.',
        singleUseCardButtonText: 'Single-Use Card',
        shoppingPassButtonText: 'Shopping Pass',
        creditIncreaseButtonText: 'Credit Increase',
        addToWallet: {
          appleWallet: {
            appleWalletMessage: 'Add your credit card to your digital wallet!',
            appleWalletImage: 'test image url',
            appleWalletImageAltText: 'Apple wallet logo',
          },
          googleWallet: {
            googleWalletMessage: 'Add your credit card to your digital wallet!',
            googleWalletImage: 'test image url',
            googleWalletImageAltText: 'Google wallet logo',
          },
          samsungWallet: {
            samsungWalletMessage:
              'Add your credit card to your digital wallet!',
            samsungWalletImage: 'test image url',
            samsungWalletImageAltText: 'Samsung wallet logo',
          },
        },
        termsAndConditionsText: 'Terms And Conditions',
      },
      singleUseCard: {
        headingText: 'Single-Use Card',
        generateCardButtonText: 'Generate Single-Use Card',
        inStoreCheckoutText: 'For in-store checkout. Valid one time only.',
        expirationWarning: 'Expires end of day card is generated.',
        backToCardSummaryButtonText: 'Back to card summary',
        accountNumberText: 'Account Number',
        expirationText: 'Expiration',
        cvvText: 'Cvv',
        presentAtCheckoutText: 'Present this at checkout',
        backToCardSummaryText: 'Back to card summary',
        maxAttemptsReachedWarningText:
          'Sorry, you’ve reached the maximum number of single-use cards for today.',
        errorText:
          'Sorry, we were unable to generate a single-use card. Please try again.',
        accountNotActivatedText:
          'Your card cannot be used to generate the Single Use Card at this time.',
      },
      shoppingPass: {
        headingText: 'Shopping Pass',
        generatePassButtonText: 'Generate Shopping Pass',
        inStoreCheckoutText: 'For in-store checkout. Valid today only.',
        expirationWarningText: 'Expires end of day card is generated.',
        backToCardSummaryButtonText: 'Back to card summary',
        presentAtCheckoutText: 'Present this at checkout',
        backToCardSummaryText: 'Back to card summary',
        errorText:
          'Sorry, we were unable to generate a single-use card. Please try again.',
      },
      profileMenu: {
        toggleLanguageLabel: 'Español',
        signOutButtonLabel: 'Sign Out',
        signInButtonLabel: 'Sign In',
      },
      sessionTimeOut: {
        sessionTimeOutHeading: 'Are you still there?',
        sessionTimeOutMessage: 'Your online session will expire in',
        sessionSecondsText: 'seconds',
        staySignedInButton: 'I’m still here',
        signOutButton: 'Sign out',
      },
      thankYou: {
        heading: 'Thanks for stopping by!',
        message: 'You’ve signed out of your Synchrony accounts.',
      },
      customerVerification: {
        header: 'Let’s Find Your Account',
        subHeader:
          'In order to make a purchase without your card, we will need to verify your identity.',
        disclaimerText:
          'By clicking “Continue”, you authorize your wireless operator to disclose your mobile number, name, address, email, network status, customer type, customer role, billing type, mobile device identifiers (IMSI and IMEI) and other subscriber and device details, if available, to Synchrony and service providers for the duration of the business relationship, solely for identity verification and fraud avoidance. See Synchrony’s Privacy Policy for how we treat your data. If you do not wish to continue, click “Cancel”. Synchrony Card Access is only available in selected locations at this time',
        lastFourSocialErrorText: 'Please enter 4 numbers',
        phoneNumberErrorText: 'Please enter 10 numbers',
        entryErrorText:
          'We can’t seem to find you. Verify your entries are correct and try submitting again.',
        continueButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        placeHolderInputSocial: 'Last 4 digits of SSN/ITIN',
        placeHolderInputPhone: 'Phone Number',
      },
      cancelModal: {
        cancelHeading: 'Are you sure you want to cancel?',
        noButtonLabelText: 'No',
        yesButtonLabelText: 'Yes',
      },
      errors: {
        genericErrors: {
          systemDown: {
            heading: 'We seem to be having trouble connecting',
            message: 'Please Try Again.',
          },
          notAuthenticated: {
            heading: 'There seems to be a connection issue',
            message: 'Please close the session and try again.',
          },
          stopByPage: {
            heading: 'Thanks for Stopping By!',
            message: 'You’ve singed out of your Synchrony accounts.',
          },
          accountNotFound: {
            heading: 'There seems to be a problem with your account',
            message:
              'We are sorry, you are currently unable to use your account. Please contact customer service.',
          },
          linkNotValid: {
            heading: 'This link is no longer valid.',
            message: 'Please Try Again.',
          },
          sessionTimeoutError: {
            heading: 'Your session timed out for your security',
            message: 'To help protect your account, your session has ended.',
          },
        },
        clientSpecificErrors: {
          tjx: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link for tjx is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry, you are currently unable to use your account. Please contact customer service on 877-890-3150',
            },
          },
          belk: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry you are currently unable to use your account. Please call customer service at 877-890-3150 for more information.',
            },
          },
          verizon: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry you are currently unable to use your account. Please call customer service at 855-220-3808 for more information.',
            },
          },
          jcrew: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry you are currently unable to use your account. Please call customer service at 855-220-3809 for more information.',
            },
          },
          lowes: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry, you are currently unable to use your account. Please contact customer service.',
            },
            lowesAccountError: {
              heading: 'We’re having trouble retrieving your account',
              subHeading: 'Please try again later.',
              contentTitle: 'Some common reasons are',
              contentLine1:
                'Your account was opened in the last 24 hours. Please see your email for temp shopping pass',
              contentLine2:
                'The phone number entered is not a cell phone (mobile)',
              contentLine3: 'The status of your account has changed',
              contentLine4:
                'Download the Lowe’s App to access your My Lowe’s Rewards Credit Card from the Wallet tab or check ',
              contentLine5:
                'your email for the temporary shopping pass sent on account open.',
            },
          },
          tru: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry you are currently unable to use your account.  Please call customer service at 855-220-3807 for more information.',
            },
          },
          aeoutfitters: {
            systemDown: {
              heading: 'We seem to be having trouble connecting',
              message: 'Please Try Again.',
            },
            notAuthenticated: {
              heading: 'There seems to be a connection issue',
              message: 'Please close the session and try again.',
            },
            stopByPage: {
              heading: 'Thanks for Stopping By!',
              message: 'You’ve singed out of your Synchrony accounts.',
            },
            linkNotValid: {
              heading: 'This link is no longer valid.',
              message: 'Please Try Again.',
            },
            sessionTimeoutError: {
              heading: 'Your session timed out for your security',
              message: 'To help protect your account, your session has ended.',
            },
            accountNotFound: {
              heading: 'There seems to be a problem with your account',
              message:
                'We are sorry you are currently unable to use your account.  Please call customer service at 855-220-3807 for more information.',
            },
          },
        },
      },
      creditLimitIncrease: {
        creditLimitText: 'Credit Limit',
        submitButtonText: 'Request Increase',
        cancelButtonText: 'cancel',
        closeButtonText: 'Close',
        requestHeading: 'Request a Credit Limit Increase',
        desiredLimitText: 'Desired Limit',
        annualNetIncomeText: 'Annual Net Income',
        annualNetIncomeInfoText: 'Include income from sources after taxes.',
        desiredAmountInfoText: 'The total credit limit amount you desire',
        annualNetIncomeZeroErrorText: 'Net Income can\'t be "0"',
        desiredAmountZeroErrorText: 'Amount can\'t be "0"',
        desiredAmountInvalidValueErrorText:
          'New credit limit must be at least $50 greater than current credit limit.',
        annualNetIncomeInvalidValueText: 'Is the income entered correctly?',
        fieldEmptyErrorText: 'This is a required field',
        fieldErrorText: 'Please verify the amount entered',
        disclosureText:
          'Your "Net Income" includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit. WI Residents Only: If this is an individual account, please also include your spouse’s income.',
        eligibilityCriteriaText:
          'Income is used to determine eligibility for a credit line increase. Subject to credit approval',
        submissionErrorText:
          'Oops, something went wrong. Please try submitting the request again.',
        cliResults: {
          approvedHeading: 'Congrats! Your credit limit increase is approved!',
          approvedMessage: 'Your credit limit was increased from',
          partiallyApprovedHeading:
            'Your credit limit increase was partially approved',
          partiallyApprovedMessage:
            'While we were not able to fully approve your request, we were able to increase your credit limit from ',
          reviewHeading: 'Thank you, your request is under review',
          declinedHeading:
            'Unfortunately, your credit limit increase was not approved.',
          newCreditLimitText: 'New Credit Limit',
          toText: 'to',
          usDollarSymbol: '$',
          cliImmediateUseText:
            'Your credit limit is available for immediate use.',
          cliExplanationLetterText:
            'You will receive a letter in 7–10 business days explaining the reason for the decision.',
        },
      },
    },
    ES: {
      header: {
        syfLogoAltText: 'Synchrony',
        userLogoAltText: 'Profile',
      },
      footer: {
        footerLinks: [
          {
            id: 'https://www.synchrony.com/syf',
            text: 'Synchrony',
            url: 'https://www.synchrony.com/',
          },
          {
            id: 'https://www.synchrony.com/privacy-policy-sp.html',
            text: 'Política de privacidad en línea',
            url: 'https://www.synchrony.com/privacy-policy-sp.html',
          },
          {
            id: 'https://www.mysynchrony.com/terms-of-use-sp.html',
            text: 'Acuerdo de uso en línea',
            url: 'https://www.mysynchrony.com/terms-of-use-sp.html',
          },
          {
            id: 'https://www.synchrony.com/gwas',
            text: 'Accesibilidad',
            url: 'https://www.synchrony.com/gwas',
          },
          {
            id: 'https://www.synchrony.com/legal/fraud-protection',
            text: 'Protección contra fraude',
            url: 'https://www.synchrony.com/legal/fraud-protection',
          },
        ],
        footerMessage:
          'Sus cuentas de crédito son emitidas por Synchrony Bank. La Política de Privacidad de Synchrony Bank rige el uso sus cuentas de crédito. El uso de este sitio se rige por el uso de la Política de Privacidad En Línea. Es posible que el contenido y los documentos que se muestran pueden no se proporcionen en español. Apple Wallet es una marca registrada de Apple Inc. Apple Pay es la marca principal y el producto que usa para pagar con solo un toque. Apple Wallet es su billetera digital. Su tarjeta está allí y puede usarla en cualquier lugar donde se acepten pagos con Apple Pay o pagos sin contacto. Google Pay, el logotipo de Google Pay y Google Play Store son marcas registradas de Google LLC.',
      },
      salutation: {
        welcomeMessage: '¡Bienvenido',
        exclamationMark: '!',
      },
      accounts: {
        cardsTitle: 'Mis Tarjetas',
        availableToSpendText: 'Disponible para gastar',
        currentLimitText: 'Límite actual',
        asOfDate: 'A partir del',
        usDollarSymbol: '$',
        portfolioLogoAltText: 'logo',
        accountPendedMessage:
          'Debería recibir su tarjeta con el número de cuenta por correo entre 7 y 10 días después de la fecha de aprobación.',
        unableToProvideAccountNumberText:
          'No podemos proporcionar su número de cuenta en este momento.',
        singleUseCardButtonText: 'Tarjeta de un solo uso',
        shoppingPassButtonText: 'Pase de compras',
        creditIncreaseButtonText: 'Aumento de crédito',
        addToWallet: {
          appleWallet: {
            appleWalletMessage:
              '¡Agrega tu tarjeta de crédito a tu billetera digital!',
            appleWalletImage:
              'https://assets.gpshopper.com/assets/751/branding/apple-wallet.png',
            appleWalletImageAltText: 'Logotipo de la billetera de Apple',
          },
          googleWallet: {
            googleWalletMessage:
              '¡Agrega tu tarjeta de crédito a tu billetera digital!',
            googleWalletImage:
              'https://assets.gpshopper.com/assets/751/branding/google-wallet.png',
            googleWalletImageAltText: 'Logotipo de la billetera de Google',
          },
          samsungWallet: {
            samsungWalletMessage:
              '¡Agrega tu tarjeta de crédito a tu billetera digital!',
            samsungWalletImage:
              'https://assets.gpshopper.com/assets/751/branding/samsung-wallet.png',
            samsungWalletImageAltText: 'Logotipo de la billetera de Samsung',
          },
        },
        termsAndConditionsText: 'Términos y condiciones',
      },
      singleUseCard: {
        headingText: 'Tarjeta de un solo uso',
        generatePassButtonText: 'Generar tarjeta de un solo uso',
        inStoreCheckoutText: 'Para pago en tienda. Válida solo una vez.',
        expirationWarning:
          'Caduca al final del día en que se genera la tarjeta.',
        backToCardSummaryButtonText: 'Volver al resumen de la tarjeta',
        accountNumberText: 'NÚMERO DE CUENTA',
        expirationText: 'VENCIMIENTO',
        cvvText: 'Cvv',
        presentAtCheckoutText:
          'Present this at checkout	Presente esto al finalizar la compra',
        backToCardSummaryText: 'Volver al resumen de la tarjeta',
        maxAttemptsReachedWarningText:
          'Lo sentimos, has alcanzado el número máximo de tarjetas de un solo uso para hoy.',
        errorText:
          'Lo sentimos, no pudimos generar una tarjeta de un solo uso. Por favor inténtalo de nuevo.',
      },
      shoppingPass: {
        headingText: 'Pase de compras',
        generatePassButtonText: 'Generar pase de compras',
        inStoreCheckoutText: 'Para pagar en tienda. Válido solo hoy.',
        expirationWarningText:
          'Caduca al final del día en que se genera la tarjeta.',
        backToCardSummaryButtonText: 'Volver al resumen de la tarjeta',
        presentAtCheckoutText: 'Presentar esto al momento de pagar',
        backToCardSummaryText: 'Volver al resumen de la tarjeta',
        errorText:
          'Lo sentimos, no pudimos generar un pase de compras. Intente nuevamente.',
      },
      profileMenu: {
        toggleLanguageLabel: 'English',
        signOutButtonLabel: 'Cerrar Sesión',
        signInButtonLabel: 'Iniciar Sesión',
      },
      sessionTimeOut: {
        sessionTimeOutHeading: 'estás ahí todavía?',
        sessionTimeOutMessage: 'Su sesión en línea caducará en',
        sessionSecondsText: 'segundos',
        staySignedInButton: 'TODAVÍA ESTOY AQUÍ',
        signOutButton: 'DESCONECTAR',
      },
      thankYou: {
        heading: '¡Gracias por pasar!',
        message: 'Por favor cierre la sesión y vuelva a intentarlo.',
      },
      customerVerification: {
        header: 'Busquemos su cuenta',
        subHeader:
          'Para realizar una compra sin su tarjeta, necesitaremos verificar su identidad.',
        disclaimerText:
          'Al hacer clic en `Continuar`, autoriza a su operador inalámbrico a revelar su número de teléfono móvil, nombre, dirección, correo electrónico, estado de la red, tipo de cliente, función del cliente, tipo de facturación, identificadores de dispositivo móvil (IMSI e IMEI) y otros detalles del suscriptor y del dispositivo. si está disponible, a Synchrony y a los proveedores de servicios durante la duración de la relación comercial, únicamente para verificación de identidad y prevención de fraude. Consulte la Política de privacidad de Synchrony para conocer cómo tratamos sus datos. Si no desea continuar, haga clic en `Cancelar`. El acceso a la tarjeta Synchrony solo está disponible en ubicaciones seleccionadas en este momento.',
        lastFourSocialErrorText: 'Por favor ingrese 4 números',
        phoneNumberErrorText: 'Por favor ingrese 10 números',
        entryErrorText:
          'Parece que no podemos encontrarte. Verifique que sus entradas sean correctas e intente enviarlas nuevamente.',
        continueButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        placeHolderInputSocial: 'Últimos 4 dígitos del SSN/ITIN',
        placeHolderInputPhone: 'Número de teléfono',
      },
      cancelModal: {
        cancelHeading: '¿Estás seguro de que quieres cancelar?',
        noButtonLabelText: 'NO',
        yesButtonLabelText: 'SI',
      },
      errors: {
        genericErrors: {
          systemDown: {
            heading: 'Parece que tenemos problemas para conectarnos.',
            message: 'Inténtelo de nuevo.',
          },
          notAuthenticated: {
            heading: 'Parece haber un problema de conexión',
            message: 'Por favor cierre la sesión y vuelva a intentarlo.',
          },
          stopByPage: {
            heading: '¡Gracias por pasar!',
            message: 'Por favor cierre la sesión y vuelva a intentarlo.',
          },
          accountNotFound: {
            heading: 'Parece que hay un problema con su cuenta.',
            message:
              'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
          },
          linkNotValid: {
            heading: 'Este enlace ya no es válido.',
            message: 'Inténtelo de nuevo.',
          },
          sessionTimeoutError: {
            heading: 'Su sesión expiró por su seguridad',
            message:
              'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
          },
        },
        clientSpecificErrors: {
          tjx: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lamentamos que no pueda utilizar su cuenta en este momento. Llame al servicio de atención al cliente al 877-890-3150 para obtener más información.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
          },
          belk: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
          },
          verizon: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
          },
          jcrew: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
          },
          lowes: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
            lowesAccountError: {
              heading: 'Tenemos problemas para recuperar su cuenta',
              subHeading: 'Por favor, intente nuevamente más tarde.',
              contentTitle: 'Algunos motivos comunes son',
              contentLine1:
                'Su cuenta fue abierta en las últimas 24 horas. Revise su correo electrónico para obtener su pase',
              contentLine2:
                'El número de teléfono ingresado no es un teléfono celular (móvil)',
              contentLine3: 'El estatus de su cuenta ha cambiado',
              contentLine4:
                'Descargue la aplicación de Lowe’s para acceder a su tarjeta de crédito My Lowe’s Rewards desde la pestaña Billetera o revise ',
              contentLine5:
                'su correo electrónico para obtener el pase de compras temporal enviado al abrir la cuenta.',
            },
          },
          tru: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
          },
          aeoutfitters: {
            systemDown: {
              heading: 'Parece que tenemos problemas para conectarnos.',
              message: 'Inténtelo de nuevo.',
            },
            notAuthenticated: {
              heading: 'Parece haber un problema de conexión',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            stopByPage: {
              heading: '¡Gracias por pasar!',
              message: 'Por favor cierre la sesión y vuelva a intentarlo.',
            },
            accountNotFound: {
              heading: 'Parece que hay un problema con su cuenta.',
              message:
                'Lo sentimos, en este momento, no puede usar su cuenta. Por favor, comuníquese con el servicio de atención al cliente.',
            },
            linkNotValid: {
              heading: 'Este enlace ya no es válido.',
              message: 'Inténtelo de nuevo.',
            },
            sessionTimeoutError: {
              heading: 'Su sesión expiró por su seguridad',
              message:
                'Para ayudar a proteger su cuenta, su sesión ha finalizado.',
            },
          },
        },
      },
      creditLimitIncrease: {
        creditLimitText: 'Límite de crédito',
        submitButtonText: 'Solicitar aumento',
        cancelButtonText: 'Cancelar',
        closeButtonText: 'Cerrar',
        requestHeading: 'Solicitar un Aumento de Límite de Crédito',
        desiredLimitText: 'Límite Deseado',
        annualNetIncomeText: 'Ingresos Netos Anuales',
        annualNetIncomeInfoText:
          'Incluya ingresos de fuentes después de impuestos.',
        desiredAmountInfoText: 'El monto del límite de crédito total que desea',
        annualNetIncomeZeroErrorText: 'El ingreso neto no puede ser "0"',
        desiredAmountZeroErrorText: 'El monto no puede ser "0"',
        desiredAmountInvalidValueErrorText:
          'El nuevo límite de crédito debe ser al menos $50 mayor que el límite de crédito actual',
        annualNetIncomeInvalidValueText: '¿Introdujo el ingreso correctamente?',
        fieldEmptyErrorText: 'Este es un campo obligatorio.',
        disclosureText:
          'Sus “Ingresos Netos” incluyen lo que gana o lo que razonablemente espera ganar por su empleo, inversiones, jubilación, beneficios del seguro social y asistencia pública. También puede incluir el dinero que otra persona deposita regularmente en su cuenta (individual o conjunta) y el monto que tiene disponible para gastar de sus activos. Si usted tiene 21 años o más, también podrá incluir el monto de los ingresos de alguna otra persona que se use periódicamente para pagar sus gastos. No es necesario incluir la cuota alimentaria, la manutención de menores ni los ingresos de manutención por separación judicial, salvo que se dependa de estos para el crédito. Residentes de Wisconsin (WI) Únicamente: Si esta es una cuenta individual, por favor también incluya los ingresos de su cónyuge.',
        eligibilityCriteriaText:
          'Los ingresos se utilizan para determinar la elegibilidad para un aumento de la línea de crédito. Sujeto a aprobación crediticia.',
        submissionErrorText:
          'Lo sentimos, algo salió mal. Intente enviar la solicitud nuevamente.',
        cliResults: {
          approvedHeading:
            '¡Felicidades! ¡Su aumento de límite de crédito está aprobado!',
          approvedMessage: 'Se aumentó su límite de crédito de',
          partiallyApprovedHeading:
            'Su aumento de límite de crédito fue aprobado parcialmente',
          partiallyApprovedMessage:
            'Si bien no pudimos aprobar completamente su solicitud, pudimos aumentar su límite de crédito de ',
          reviewHeading: 'Gracias, su solicitud está bajo revisión.',
          declinedHeading:
            'Desafortunadamente, su aumento de límite de crédito no fue aprobado.',
          newCreditLimitText: 'Nuevo límite de crédito',
          toText: 'a',
          usDollarSymbol: '$',
          cliImmediateUseText:
            'Su límite de crédito está disponible para uso inmediato.',
          cliExplanationLetterText:
            'Recibirá una carta en un plazo de 7 a 10 días hábiles donde se explica el motivo de la decisión.',
        },
      },
    },
  },
};
